import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FlaskConical } from "lucide-react";

/** PREVIEW ONLY — the seeded design fleet is deliberately convincing, so every surface a
 *  SEED_ truck can reach says so in words that cannot be mistaken for real inventory.
 *
 *  NOT dismissible on purpose: a banner someone can close is a banner someone closes on day
 *  one and screenshots on day three. In production no SEED_ row exists, the endpoint returns
 *  active=false, and this renders nothing at all. */
export function SyntheticDataBanner({ testid = "synthetic-banner" }) {
  const [st, setSt] = useState(null);
  useEffect(() => {
    let live = true;
    api.get("/preview-synthetic").then(({ data }) => live && setSt(data)).catch(() => {});
    return () => { live = false; };
  }, []);
  if (!st?.active) return null;
  return (
    <div data-testid={testid} className="mb-4 rounded-xl bg-[#B01E28] px-4 py-3 text-white shadow-md ring-2 ring-[#B01E28]/30">
      <div className="flex items-start gap-3">
        <FlaskConical className="w-5 h-5 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="font-mono text-[11px] font-bold uppercase tracking-[0.18em]">
            Synthetic test data on screen — not real fleet
          </div>
          <p className="text-sm mt-1 leading-relaxed text-white/95">
            <b data-testid="synthetic-count" className="font-mono">{st.synthetic}</b> of{" "}
            <b className="font-mono">{st.active_total}</b> vehicles are <b>seeded fakes</b> (stock numbers
            start <span className="font-mono">{st.prefix}</span>). Every count, search result and export
            on this screen includes them. Real fleet:{" "}
            <b data-testid="synthetic-real-count" className="font-mono">{st.real}</b>.
          </p>
        </div>
      </div>
    </div>
  );
}
